/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 * 
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$data as ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation,
	ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$variables as ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutationVariables,
} from '../__generated__/ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation.graphql.ts';

// Nested types extracted from Relay-generated types
import type { ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$data } from '../__generated__/ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation.graphql.ts';
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_ResolveRestrictionsPayload_errors_MutationError = NonNullable<NonNullable<ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$data['resolveRestrictionsForSubjects']>['errors'][number]>;
export type ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation_resolveRestrictionsForSubjects_ResolveRestrictionsPayload = NonNullable<ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation$data['resolveRestrictionsForSubjects']>;

// GraphQL input types re-exported from Relay artifact
export type { BlockedAccessSubjectInput } from '../__generated__/ResolveRestrictionsDialogResolveRestrictionsForSubjectsMutation.graphql.ts';

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum BlockedAccessSubjectType {
  GROUP = "GROUP",
  USER = "USER",
}

export enum ResourceAccessType {
  EDIT = "EDIT",
  VIEW = "VIEW",
}

